export const list = {
  title: {
    name: '成员',
    key: 'title',
    fixed: true,
    expand: true
  },
  total_number_of_tasks: {
    name: '任务总数',
    key: 'total_number_of_tasks'
  },
  completed_number_of_tasks: {
    name: '已完成',
    key: 'completed_number_of_tasks'
  },
  undone_number_of_tasks: {
    name: '未完成',
    key: 'undone_number_of_tasks'
  },
  overdue_number_of_tasks: {
    name: '逾期',
    key: 'overdue_number_of_tasks'
  },
  archived_number_of_tasks: {
    name: '已归档',
    key: 'archived_number_of_tasks'
  }
};
